import { capture } from '../sentry/capture';
import cleanAll from './cleanAll';
import toast from 'react-hot-toast';

const reloadPage = () => {
  setTimeout(function() {
    window.location.assign('/');
  }, 2000);
};

const clickToCleanSW = async () => {
  try {
    await cleanAll();
    toast.success('Mise à jour : succès');
    reloadPage();
  } catch (e) {
    toast.error('Mise à jour : échec');

    capture(e, [{ key: 'detail', extra: e }]);
    reloadPage();
  }
};
export { clickToCleanSW };
